import openWindow from '@/script/openWindow.mjs'
import {useIsLicensed} from '@/biz/license.jsx'

export const canDesignUv = () => () => {
    const isLicensed = useIsLicensed()

    if (isLicensed('M00030002')) {
        return function (nodes) {
            return [...nodes].filter(node => {
                const {bizNodeType, demoType, pkid} = node.data

                return (
                    pkid &&
                    'UV' === bizNodeType &&
                    'DEMO' === demoType
                )
            })
        }
    }
    else {
        return () => []
    }
}

export const designUv = () => () => {
    return async function (nodes) {
        for (const n of nodes) {
            const {pkid: uvId} = n.data
            openWindow('/UvDetail', {uvId})
        }
    }
}
